module.exports = __webpack_public_path__ + "static/media/Circo2025_15.7731c396.webp";